// src/components/Footer/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import Mascot from '../Mascot';
import '../../styles/components/Footer.css';
import logo from '../../assets/michii_logo_transparent.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <img src={logo} alt="Michii" className="footer-logo" />
        <p className="footer-copy">&copy; {currentYear} Michii</p>
        <nav className="footer-links" aria-label="Legal and contact">
          <Link to="/faq" className="footer-link">FAQ</Link>
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms &amp; Conditions</Link>
          <Link to="/contact" className="footer-link">Contact Us</Link>
        </nav>
        <Mascot size={28} className="footer-mascot" />
      </div>
    </footer>
  );
};

export default Footer;
